export * from './Data';
export * from './Action';
export { reducer } from './Store';

import CMSPage from './Page/CMSPage';

export const Pages = {
  CMSPage
};
